import * as Sentry from '@sentry/react';

const serverList = [
  'ap-south-1',
  'ap-northeast-3',
  'ap-northeast-2',
  'ap-southeast-1',
  'ap-southeast-2',
  'ap-northeast-1',
  'ca-central-1',
  'eu-central-1',
  'eu-west-1',
  'eu-west-2',
  'eu-west-3',
  'eu-north-1',
  'sa-east-1',
  'us-east-1',
  'us-east-2',
  'us-west-1',
  'us-west-2',
];

let latencyTestStarted = false;
export const runRegionLatencyTest = async () => {
  if (latencyTestStarted) return;
  latencyTestStarted = true;
  const route53Guess = fetch('https://best-latency.thmcell.click/api/region')
    .then((res) => res.json())
    .then((data) => data.region as string)
    .catch(() => undefined);
  const promises = serverList.map((server) => {
    return new Promise<{ server: string; averageLatency: number; latencies: number[] }>((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        ws.close();
        reject(`Timeout connecting to ${server}`);
      }, 30000); // 30 second timeout

      const ws = new WebSocket(`wss://${server}-latency.thmcell.click/ws`);
      const latencies: number[] = [];
      let pingCount = 0;

      ws.onopen = () => {
        const sendPing = () => {
          if (pingCount >= 5) {
            const averageLatency = latencies.reduce((a, b) => a + b, 0) / latencies.length;
            clearTimeout(timeoutId);
            ws.close();
            resolve({ server, averageLatency, latencies });
            return;
          }
          pingCount++;
          const sentAt = performance.now();
          ws.send(JSON.stringify({ type: 'ping', id: pingCount, sentAt }));
        };

        ws.onmessage = (event) => {
          const pong = JSON.parse(event.data);
          if (pong.type === 'pong') {
            const latency = performance.now() - pong.sentAt;
            latencies.push(latency);
            sendPing();
          }
        };

        sendPing();
      };

      ws.onerror = (error) => {
        clearTimeout(timeoutId);
        reject(`Failed to connect to ${server}`);
      };
    });
  });
  const promiseResults = await Promise.allSettled(promises);
  if (promiseResults.some((result) => result.status === 'rejected')) {
    Sentry.logger.error('Region latency test failed', { promiseResults });
    return;
  }
  const results = promiseResults.filter((result) => result.status === 'fulfilled').map((result) => result.value);
  results.sort((a, b) => a.averageLatency - b.averageLatency);
  const attributes: Record<string, number | string | undefined> = {
    bestRegion: results?.[0]?.server,
    bestRegionDelta: (results?.[1]?.averageLatency ?? 0) - (results?.[0]?.averageLatency ?? 0),
    route53BestRegionGuess: await route53Guess,
  };
  for (const result of results) {
    attributes[result.server] = result.averageLatency;
  }
  Sentry.logger.info('Region latency test results', attributes);
};
